import { useWindowSize } from "@lux/atoms/hooks/useWindowSize";
import React, { useEffect, useRef, useState } from "react";

/**
 * This holds a visx chart and serves multiple purposes
 * - Measure the width of the component
 * - Show a loading indicator
 */
export const ChartContainer = ({
  children,
}: {
  children?: ({ width }: { width: number }) => React.ReactNode;
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState<number | null>(null);
  const windowSize = useWindowSize();

  useEffect(() => {
    if (ref && ref.current) {
      setWidth(ref.current.offsetWidth);
    }
  }, [windowSize, ref]);

  return (
    <div className={"full-width"} ref={ref}>
      {!width ? <div>Loading...</div> : children?.({ width })}
    </div>
  );
};
